import React, { useState } from "react";
import "./settings.css";
import { Navigate } from "react-router-dom";
import { SettingsNav } from "./settings-nav";
import { AccountSettings } from "./account-settings";
import { FamilySettings } from "./family-settings";
import { AppearanceSettings } from "./appearance-settings";
import { ContactSettings } from "./contact-settings";
import { ProblemSettings } from "./problem-settings";

export const Settings = () => {
  const [active, setActive] = useState("Account");
  if (!document.cookie) return <Navigate to="/signin?next=settings" />;

  const settingsToRender = () => {
    switch (active) {
      case "Account":
        return <AccountSettings className="setting-tab" />;
      case "Family":
        return <FamilySettings className="setting-tab" />;
      case "Appearance":
        return <AppearanceSettings className="setting-tab" />;
      case "Contact":
        return <ContactSettings className="setting-tab" />;
      case "Problem":
        return <ProblemSettings className="setting-tab" />;
      default:
        return <AccountSettings className="setting-tab" />;
    }
  };

  return (
    <div className="settings-container">
      <SettingsNav setActive={setActive} active={active} />
      {settingsToRender()}
    </div>
  );
};
